import { ROLES } from '@/shared/constants';

export const comprobarPermisos = ( router ) => {
  const permisosUsuario = localStorage.getItem('permisos');
  const requiredPermission = router.meta.requiredPermission;
  if (!permisosUsuario.includes(requiredPermission)) {
    // router.push({ name: "not-permitted" });
  } else {
    console.log("El usuario tiene permiso para acceder a esta ruta.");
  }
}



export const comprobarRoles = (rolesBuscados) => {

  const datLS  = localStorage.getItem('detalleusuario');

  if (!datLS) {
    console.error('No se encontró el detalleusuario en localStorage.');
    return false;
  }

  const { roles } = JSON.parse(datLS);

  const rolesArray = (!Array.isArray(rolesBuscados))
    ?  [rolesBuscados, ROLES.TECNICO]
    :  [...rolesBuscados, ROLES.TECNICO];

  return rolesArray.some(rolBuscado => roles.some(rol => rol.codigo === rolBuscado));

}